module.exports = "/_next/static/images/47632a3444a56393ef5475b9f0d30233-mb-hero-lg-experiment.jpg.webp";